import React from 'react';
import {connect} from "react-redux";
import downloadCsvIcon from "../../../assets/icons/download-csv-icon.svg";
import {t} from "i18next";

const CsvReport = ({data, disabled, filters }) => {
  const isUnavailableData = data === t('unableToFetchData') || data === 'No data available for this report';
  const isDisabled = disabled || !data;

  const handleDownload = () => {
    const csvData = `data:text/csv;charset=utf-8,${encodeURIComponent(data)}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = csvData;
    downloadLink.download = `${filters.year}-${filters.duration}_${filters.period}-Reports.csv`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div className="report">
      <div className="download-csv-icon-container">
        <figure
          className={`download-csv ${isDisabled ? 'disabled' : ''}`}
          onClick={data && !isUnavailableData ? handleDownload : undefined}>
          { (disabled || !isUnavailableData) && (
            <img
              className="download-csv-icon"
              src={downloadCsvIcon}
              alt={`${filters.year}-${filters.duration}_${filters.period}-Reports.csv`}
              style={{cursor: isDisabled ? 'not-allowed' : 'pointer' }}
            />
          )}
          { disabled ? (
            <figcaption
              className="download-csv-caption">
              {t('generatingReport')}
            </figcaption>
          ) : ( data &&
            <figcaption
              className="download-csv-caption"
              style={{cursor: !isUnavailableData ? 'pointer': 'default'}}>
              { isUnavailableData ? data : t('downloadFile')}
            </figcaption>
          )}
        </figure>
      </div>
    </div>
  );
};

export default connect()(CsvReport);
